<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('banners')">
            <app-default-button
                    :title="$addLabel('banner')"
                    @click="openModal"
            />
        </app-page-top-section>

        <app-table
                id="banners-table"
                :options="options"
                @action="triggerActions"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('banners-table')"
                @cancelled="confirmationModalActive = false"
        />

        <app-banner-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
        />

    </div>
</template>

<script>
    import {BANNERS} from "../../../Config/ApiUrl";
    import {actionColumn, htmlColumn, textColumn} from "../../../Helpers/TableCommonColumn";
    import {createdFilter} from "../../../Helpers/TableFIlter";
    import {deleteAction, editAction} from "../../../Helpers/TableAction";
    import DatatableHelperMixin from "../../../Mixins/DatatableHelperMixin";

    export default {
        name: "Banners",
        mixins: [DatatableHelperMixin],
        data() {
            return {
                options: {
                    name: this.$allLabel('banners'),
                    url: BANNERS,
                    responsive: true,
                    columns: [
                        textColumn(this.$t('url'), 'page_url'),
                        htmlColumn(this.$t('image'), 'path', path => {
                            return `<img src="${path}" alt="Banner" style="height: 50px; width: auto" />`;
                        }),
                        actionColumn(),
                    ],
                    filters: [
                        createdFilter()
                    ],
                    actionType: "dropdown",
                    actions: [
                        editAction(this.$can('update_banners'), BANNERS),
                        deleteAction(this.$can('delete_banners'), BANNERS),
                    ],
                    rowLimit: 10,
                    paginationType: "pagination"
                },
                isModalActive: false,
                selectedUrl: ''
            }
        },
        methods: {
            openModal() {
                this.isModalActive = true;
                this.selectedUrl = '';
            },
            triggerActions(row, action, active) {
                if (action.key === 'edit') {
                    this.isModalActive = true;
                    this.selectedUrl = `${this.apiUrl.BANNERS}/${row.id}`
                } else if (action.name === 'delete') {
                    this.delete_url = `/${this.apiUrl.BANNERS}/${row.id}`
                    this.confirmationModalActive = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>